import { render, staticRenderFns } from "./IndividualReportsList.vue?vue&type=template&id=6a10657e&"
import script from "./IndividualReportsList.vue?vue&type=script&lang=js&"
export * from "./IndividualReportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports